import React from 'react';
import { StyledContainer, StyledCountText } from './styles';

type Props = {
  totalCount: number;
};

const SettlementListByBrandToolbar = ({ totalCount }: Props): JSX.Element => {
  return (
    <>
      <StyledContainer>
        <StyledCountText>
          <span>{totalCount}</span>건이 조회되었습니다.
        </StyledCountText>
      </StyledContainer>
    </>
  );
};

export default SettlementListByBrandToolbar;
